import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0b3d5c] text-white">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2.5 group">
              <img src="/logo192.png" alt="Plantão da Saúde" className="h-10 w-10 rounded-xl" width={40} height={40} loading="lazy" />
              <div>
                <span className="text-lg font-bold tracking-tight block">Plantão da Saúde</span>
                <span className="text-[10px] font-medium text-blue-300 uppercase tracking-[0.2em]">IJF-AD</span>
              </div>
            </Link>
            <p className="text-blue-200/70 text-sm leading-relaxed">
              Instituto Jurídico Federal da Ampla Defesa. Promovendo acesso gratuito à justiça em saúde.
            </p>
            <p className="text-blue-300/50 text-xs">CNPJ: 58.957.260/0001-30</p>
            <div className="flex items-center gap-3 pt-1">
              <a href="https://www.instagram.com/plantaodasaude.ong" target="_blank" rel="noopener noreferrer" className="text-blue-300/50 hover:text-white transition-colors" aria-label="Instagram">
                <Instagram className="h-4.5 w-4.5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider text-white/80">Navegação</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                {name:'Quem Somos',path:'/quem-somos'},
                {name:'Serviços',path:'/servicos'},
                {name:'Transparência',path:'/transparencia'},
                {name:'FAQ',path:'/faq'},
                {name:'Contato',path:'/contato'},
                {name:'Doações',path:'/doacoes'}
              ].map((item) => (
                <Link key={item.path} to={item.path} className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200">
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider text-white/80">Contato</h4>
            <div className="space-y-3.5">
              <a href="tel:08000002560" className="flex items-start gap-3 text-blue-200/60 hover:text-white transition-colors text-sm group">
                <Phone className="h-4 w-4 mt-0.5 shrink-0 text-blue-400/70 group-hover:text-white transition-colors" />
                <div>
                  <span className="block font-medium text-white">0800 000 2560</span>
                  <span className="text-xs text-blue-300/50">Atendimento 24h</span>
                </div>
              </a>
              <a href="mailto:contato@plantaodasaude.org" className="flex items-center gap-3 text-blue-200/60 hover:text-white transition-colors text-sm">
                <Mail className="h-4 w-4 shrink-0 text-blue-400/70" />
                contato@plantaodasaude.org
              </a>
              <div className="flex items-start gap-3 text-blue-200/60 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-blue-400/70" />
                <span>Goiânia – GO, Brasil</span>
              </div>
            </div>
          </div>

          {/* Transparency */}
          <div className="space-y-4">
            <h4 className="font-semibold text-sm uppercase tracking-wider text-white/80">Transparência</h4>
            <p className="text-blue-200/60 text-sm leading-relaxed">Comprometidos com a prestação de contas e clareza em todas as nossas ações.</p>
            <Link to="/transparencia" className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-300/80 hover:text-white transition-colors">
              Ver relatórios <ExternalLink className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/[0.08]">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-blue-300/50 text-xs">&copy; {new Date().getFullYear()} Plantão da Saúde — IJF-AD. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4 text-xs">
            <Link to="/privacidade" className="text-blue-300/50 hover:text-white transition-colors">Política de Privacidade</Link>
            <span className="text-white/10">|</span>
            <Link to="/termos" className="text-blue-300/50 hover:text-white transition-colors">Termos de Uso</Link>
            <span className="text-white/10">|</span>
            <Link to="/transparencia" className="text-blue-300/50 hover:text-white transition-colors">Transparência</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;